import { createAction } from 'redux-act';

export const changeMenuState = createAction<boolean>();